module.exports = __webpack_public_path__ + "static/media/46-iveco-mercedes.cd8a9958.jpg";